
<template>
  <v-container fluid style="padding: 0">
    <header>
      
      <div class="grayBar">
        <div class="grayBar-inner">
          <a href="https://www.regione.emilia-romagna.it">Regione Emilia-Romagna</a>
        </div>
      </div>
      
      <div class="logo">
          <a
            class="logoLink"
            title="Home"
            target="_blank"
            href="https://protezionecivile.regione.emilia-romagna.it"
          >

            <!-- Logo RER -->
            <v-img alt="" 
              contain 
              :max-height="$vuetify.breakpoint.smAndDown? 42 : 100" 
              :max-width="$vuetify.breakpoint.smAndDown? 42 : 100" 
              :src="require('../assets/logo.png')" />

            <span class="headerLogo">Agenzia per la sicurezza territoriale e la protezione civile</span>

            <!-- Logo vigili del fuoco -->
            <v-img alt=""
              contain 
              :max-height="$vuetify.breakpoint.smAndDown? 42 : 100" 
              :max-width="$vuetify.breakpoint.smAndDown? 42 : 100" 
              
              :src="require('../assets/logo_vvf.jpg')" />
          </a>

          <div
            v-on:click="navDrawer = true"
            style="display: none; padding: 5px 15px 5px 10px; font-size: 24px; cursor: pointer"
            class="mobile-only"
          >
            <svg
              class="svg-inline--fa fa-bars fa-w-14"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="bars"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              data-fa-i2svg=""
            >
              <path
                fill="currentColor"
                d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
              ></path>
            </svg>
          </div>
      </div>
    </header>

    <div id="portal-mainnavigation">
      <nav aria-label="Sezioni" class="globalnavWrapper">
        <ul role="list" id="portal-globalnav">
          <li id="portaltab-0" class="plain">
            <a
              href="https://protezionecivile.regione.emilia-romagna.it/agenzia"
              data-tabid="0"
              class="menuTabLink clickandgo"
              ><span>L'Agenzia</span></a
            >
          </li>

          <li id="portaltab-1" class="plain">
            <a
              href="https://protezionecivile.regione.emilia-romagna.it/aree-tematiche/aree-tematiche"
              data-tabid="1"
              class="menuTabLink clickandgo"
              ><span>Aree tematiche</span></a
            >
          </li>

          <li id="portaltab-2" class="plain">
            <a
              href="https://protezionecivile.regione.emilia-romagna.it/come-fare-per/come-fare-per"
              data-tabid="2"
              class="menuTabLink clickandgo"
              ><span>Come fare per</span></a
            >
          </li>
        </ul>
      </nav>
    </div>
    <div class="grayBarThin">
      <div class="logo" style="padding: 0">
        <a
          style="margin: 0 10px; line-height: 2.7"
          href="https://protezionecivile.regione.emilia-romagna.it"
          aria-label="Torna al sito"
        >
          <svg
            style="width: 24px; height: 24px; color: #cb1d15"
            viewBox="0 0 24 24"
          >
            <path
              fill="#cb1d15"
              d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z"
            />
          </svg>
        </a>
      </div>
    </div>
    <v-navigation-drawer fixed temporary right v-model="navDrawer">
      <nav aria-label="Sezioni" class="globalnavWrapper">
        <div class="globalnavClose">
          <button
            aria-controls="menu"
            aria-label="Esci dalla navigazione"
            title="Esci dalla navigazione"
            class="globalnav-close"
            v-on:click="navDrawer = false"
          >
            <!-- <v-icon>mdi-close-thick</v-icon> -->
            <svg
              style="width: 40px; height: 35px; margin: 3px 0"
              viewBox="0 0 24 24"
            >
              <path
                fill="white"
                d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
              />
            </svg>
            <span class="sr-only">chiudi</span>
          </button>
        </div>
        <ul class="globalnav-links" role="menubar" id="portal-globalnav-links">
          <li id="portaltab-links-0" class="plain">
            <a
              href="https://protezionecivile.regione.emilia-romagna.it/agenzia"
              data-tabid="0"
              class="menuTabLink clickandgo"
              ><span>L'Agenzia</span></a
            >
          </li>

          <li id="portaltab-links-1" class="plain">
            <a
              href="https://protezionecivile.regione.emilia-romagna.it/aree-tematiche/aree-tematiche"
              data-tabid="1"
              class="menuTabLink clickandgo"
              ><span>Aree tematiche</span></a
            >
          </li>

          <li id="portaltab-links-2" class="plain">
            <a
              href="https://protezionecivile.regione.emilia-romagna.it/come-fare-per/come-fare-per"
              data-tabid="2"
              class="menuTabLink clickandgo"
              ><span>Come fare per</span></a
            >
          </li>
        </ul>
      </nav>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
export default {
  name: "header-emilia",
  data() {
    return {
      navDrawer: false,
    };
  },
  methods: {
    goBack() {
      this.$store.commit("setCurrentFire", null);
      this.$router.push({
        path: "/",
      });
    },
    onSelect(fire) {
      this.$store.commit("setCurrentFire", fire);
      this.$router.push({
        path: "/",
      });
    },
  },
  computed: {
    fires() {
      // console.log("this.$store.getters.fires: " + this.$store.getters.fires);
      return this.$store.getters.fires;
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped lang="scss">
.globalnav-close {
  height: 50px;
  font-size: 10px;
  display: block;
  background: #cb1d15;
  width: 100%;
  border: 0;
  color: #fff;
  padding: 5px 10px;
  text-align: left;
}

.globalnav-links {
  margin: 0;
  padding: 0;
}

.globalnav-links li {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  list-style: none;
}

.globalnav-links li a {
  display: block;
  position: relative;
  padding: 10px 16px;
  padding-right: 20px;
  border: 0;
  text-decoration: none;
}

.globalnav-links li a span {
  display: inline-block;
  padding-right: 5px;
  font-size: 12px;
  font-weight: 600;
}

.title {
  height: 100%;
  width: 50%;
  float: center;

  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.grayBar {
  height: 52.4px;
  background-color: #eee;
}

.grayBarThin {
  height: 35px;
  background-color: #eee;
}

.logo {
  padding: 16px 8px;
  margin: auto;
  width: 90%;
  max-width: 1080px;
  display: flex;
}

// .logo + div {
//   padding: 18px 15px;
//   margin-top: 0;
//   margin-bottom: 0;
//   flex-grow: 0.8;
// }

.logo svg {
  width: 21px;
  height: 24px;
  display: inline-block;
}

.logoLink {
  text-decoration: none;
  margin: 0 auto 0 0;
  color: #1c2024;
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
}

.logoLink img {
  /* margin-right: 20px; */
  height: 100%;
}

.logoLink span {
  border-bottom: 3px solid rgba(0, 0, 0, 0);
  font-size: 34px;
  font-weight: 600;
  line-height: 1.3;
}

.logoLink span:hover {
  border-bottom: 3px solid rgba(0, 0, 0, 1);

}

.headerLogo { margin: 0px 8px; min-width: 160px; }

* {
  font-family: "Titillium Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 18px;
  line-height: 1.5;
  color: #1c2024;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#portal-mainnavigation .globalnavWrapper {
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
  background-color: #cb1d15;
}

#portal-mainnavigation ul#portal-globalnav {
  display: flex;
  justify-content: center;
  padding: 0;
}

#portal-mainnavigation ul#portal-globalnav > li:first-child {
  margin-left: 0;
}

#portal-mainnavigation ul#portal-globalnav li {
  padding: 12px 2%;
  list-style: none;
  margin: 0;
}

#portal-mainnavigation ul#portal-globalnav li a.menuTabLink {
  display: block;
  position: relative;
  padding-right: 20px;
  border: 0;
  text-decoration: none;
}

#portal-mainnavigation ul#portal-globalnav li a.menuTabLink span {
  border-bottom: 1px solid transparent;
  color: white;
  font-weight: 600;
  font-size: 19.5px;
}

#portal-mainnavigation ul#portal-globalnav li a.menuTabLink span:hover {
  border-bottom: 1px solid white;
}

.sr-only {
  visibility: hidden;
}

@media (min-width: 991px) {
  .mobile-only {
    display: none;
  }
}

@media (max-width: 600px) {
/*  .logoLink img {
    width: 13vw;
    height: 13vw;
    margin-right: 15px;
  }
*/
}

@media (max-width: 991px) {
  .logoLink span {
    font-size: 4.2vw;
  }

  .logo {
    //border-bottom: 1px solid #777;
    width: 100%;
  }

  .grayBarThin {
    border-bottom: 1px solid #777;
  }

  #portal-mainnavigation .globalnavWrapper {
    display: none;
  }
}

.grayBar a {
//  font-size: 16px !important;
  color: black;
  text-transform: none;
  text-decoration: none;
  font-weight: 600;
}

.grayBar-inner {
    width: 90%;
    max-width: 1080px;
    text-align: left;
    margin-right: auto;
    margin-left: auto;
    padding-top: 12px;
    padding-left: 8px;
}

</style>